import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import Crossing from './Crossing';
import PacSuccess from './PacSuccess';
import { env } from '../env';

const downloadButton = (value: boolean): string =>
  value ? 'btn primary button-pay loading' : 'btn primary button-pay';

interface ISuccessProps {
  name: string;
  email: string;
  priceUF: string;
  priceCLP: string;
  proposal: number;
  mandateId: string;
  nameBank: string;
  reset: () => void;
  fetching: boolean;
  pdf: string;
  enableDownload: boolean;
  getPdf: (proposal: number) => void;
  planName: string;
  documentId: string;
}

export default function Success(props: ISuccessProps) {
  const {
    name,
    email,
    priceCLP,
    priceUF,
    proposal,
    reset,
    mandateId,
    nameBank,
    fetching,
    pdf,
    enableDownload,
    getPdf,
    planName,
    documentId
  } = props;

  const downloadPdf = () => window.open(pdf, '_blank');

  useEffect(() => {
    getPdf(proposal);
  }, [getPdf, proposal]);

  useEffect(() => {
    if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
      ReactGA.send({
        hitType: 'pageview',
        location: 'salud.segurosfalabella.com/salud/exito',
        title: 'Seguro Salud Complementario',
      });

      // Funnel step viewed
      ReactGA.event("funnel_step_viewed", {
        'funnel_name': 'contratacion-seguro',
        'product_name': 'web-salud-complementario',
        'funnel_step_name': 'paso-exito'
      });

      // Purchase
      ReactGA.event("purchase", {
        'transaction_id': proposal.toString(),
        'value': priceCLP,
        'currency': 'CLP',
        'items': [
          {
            'item_id': proposal,
            'item_name': planName,
            'item_brand': 'Metlife',
            'price': priceCLP,
          }
        ]
      });

      // User Identified
      ReactGA.event("user_identified", {
        'user_id': `CL_RUT_${documentId}`,
      });
    }
  }, [priceCLP, proposal, planName, documentId])

  return (
    <>
      <div className="container mb30">
        <div className="row">
          <div className="col-12 col-md-10 wizard-card message message__success mt50">
            <div className="row">
              <div className="col-12 text-center message--title">
                <h1>{`¡Felicitaciones ${name}!`}</h1>
              </div>
              <div className="col-12 col-sm-10 mx-auto">
                <div className="row">
                  <div className="col-12 col-sm-3 col-md-2 message--icon-container">
                    <i className="material-icons message--icon">check</i>
                  </div>
                  <div className="col-12 col-sm-9 col-md-10">
                    <p>Ya te encuentras protegido.</p>
                    <p>
                      Acabas de contratar tu SEGURO COMPLEMENTARIO DE SALUD con
                      la compañia METLIFE por una prima mensual de ${priceCLP}{' '}
                      UF {priceUF}
                    </p>
                    <p>
                      Tu número de propuesta es el{' '}
                      <span className="text-bold">{proposal}</span>
                    </p>
                    {!enableDownload && (
                      <p>
                        En las próximas 72 horas hábiles enviaremos tu
                        certificado de cobertura al correo&nbsp;
                        <span className="text-bold">{email}</span>
                      </p>
                    )}
                  </div>
                  {enableDownload && (
                    <div className="col-12 col-sm-4 mx-auto">
                      <button
                        className={downloadButton(fetching)}
                        disabled={fetching}
                        onClick={downloadPdf}
                        type="button"
                      >
                        <span>
                          <i className="material-icons align-middle mr10">
                            save_alt
                          </i>
                          Descargar póliza
                        </span>
                        {fetching && <i className="element-spinner" />}
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {mandateId && (
                <PacSuccess mandateId={mandateId} nameBank={nameBank} />
              )}
              <div className="col-12 col-sm-4 mx-auto mt20">
                <button
                  className="btn white btn--hover-green"
                  type="button"
                  onClick={reset}
                >
                  Adquirir otro seguro
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Crossing />
    </>
  );
}
